module.exports = __webpack_public_path__ + "static/media/WAP-banner2.48dbd380.png";